import { useNavigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { Auth } from '../../types';

type BadgeProps = {
  navigate: (to: string) => void;
  t: (label: string) => string;
};

type LoggedBadgeProps = BadgeProps & {
  auth: Auth;
};

const NotLoggedBadge = ({ navigate, t }: BadgeProps) => (
  <>
    {t('not logged')} (
    <Button
      size="small"
      onClick={() => {
        navigate('/login');
      }}
    >
      {t('signin')}
    </Button>
    )
  </>
);

const LoggedBadge = ({ navigate, t, auth }: LoggedBadgeProps) => (
  <>
    👤 {auth?.user?.session?.descrizione} (
    <Button
      size="small"
      onClick={() => {
        auth?.signout(() => navigate('/'));
      }}
    >
      {t('signout')}
    </Button>
    )
  </>
);

const AuthStatus = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="absolute bottom-[-6px] right-1">
      {!auth?.user?.isAuthenticated ? (
        <NotLoggedBadge t={t} navigate={navigate} />
      ) : (
        <LoggedBadge t={t} navigate={navigate} auth={auth} />
      )}
    </div>
  );
};

export default AuthStatus;
